import { render, staticRenderFns } from "./ApplicationHeader.vue?vue&type=template&id=bf0d7f1a&"
import script from "./ApplicationHeader.vue?vue&type=script&lang=ts&"
export * from "./ApplicationHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports